import { useQuery } from '@tanstack/react-query';
import type { CustomGroupSearch, CustomGroupSearchResponse } from '@metron/shared';
import { toCustomGroupSearchParams } from '@metron/shared';
import { useApiClient } from './useApiClient.ts';

/**
 * Runs a Smart Search custom group spec against `GET /custom-groups/filter` (MET-3529).
 * Same caching and previous-page behavior as `useMeterFilter`.
 */
export function useCustomGroupFilter(spec: CustomGroupSearch | null) {
  const apiClient = useApiClient();
  const params = spec ? toCustomGroupSearchParams(spec).toString() : '';

  return useQuery({
    queryKey: ['custom-group-filter', params],
    queryFn: () => apiClient.get<CustomGroupSearchResponse>(`custom-groups/filter?${params}`),
    enabled: spec !== null,
    placeholderData: (previous) => previous,
  });
}
